/**
 * One tooltip open at a time, app-wide (owner feedback 2, G2; fb2 M3). The
 * hints (`useHint`, their own store) and the plain react-tooltip tooltips
 * (`PortalTooltip`: the viewer toolbar's `ToggleIconButton`,
 * `FloatingToolbarButton tooltip=`, …) share the primitive, so they share this
 * slot too: whichever opens closes the one that was open.
 */
let current: { id: string; close: () => void } | null = null;

/** `id` is opening: the tooltip open until now (another id) is closed. */
export function claimTooltip(id: string, close: () => void) {
  const prev = current;
  current = { id, close };
  if (prev && prev.id !== id) prev.close();
}

/** `id` closed by itself: the slot is free (a no-op when another one holds it). */
export function releaseTooltip(id: string) {
  if (current?.id === id) current = null;
}

/** The id holding the slot (tests). */
export const openTooltipId = () => current?.id ?? null;
